import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Analytics } from '@vercel/analytics/react';
import App from './App';
import { Toaster } from '@/components/ui/toaster';
import { ConfirmProvider } from '@/components/ui/confirm';
import { initSentry, Sentry } from '@/lib/sentry';
import './styles/globals.css';

// Sentry first so any setup errors are captured.
initSentry();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<CrashScreen />}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ConfirmProvider>
            <App />
            <Toaster />
            <Analytics />
          </ConfirmProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

function CrashScreen() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-bone px-6 text-center text-ink">
      <p className="font-mono text-[10px] uppercase tracking-widest text-ink-muted">
        Something broke
      </p>
      <h1 className="text-2xl font-medium tracking-tightest">Quietly, of course.</h1>
      <p className="max-w-sm text-sm text-ink-muted">
        Sorry — Haphe ran into an unexpected error. We've been notified. Try
        reloading.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="rounded-full bg-ink px-5 py-2 text-sm font-medium text-bone transition-colors hover:bg-ink-soft"
      >
        Reload
      </button>
    </div>
  );
}
